const FarmsServiceFactory = ({ HTTPFarms }) => {
    return {
        getFarms: () => {
            return HTTPFarms.get(`farms`).then((res) => res.data);
        },
        getFarmParams: (farmId) => HTTPFarms.get(`farm/${farmId}/params`).then((res) => res.data),
    };
};
export default FarmsServiceFactory;
//# sourceMappingURL=farms.api.js.map